import React from 'react'
import { ColorValue } from 'react-native'
import Svg, { Path } from 'react-native-svg'

interface StreakIconProps {
  width?: number
  height?: number
  withBorder?: boolean
  borderColor?: ColorValue
}

const StreakIcon = ({
  width = 20,
  height = 20,
  withBorder = false,
  borderColor,
}: StreakIconProps) => {
  const flamePath1 =
    'M5.61719 5.10941C4.41406 6.92191 3.42969 9.00003 3.42969 10.9375C3.42969 12.678 ' +
    '4.12109 14.3472 5.3518 15.5779C6.58251 16.8086 8.2517 17.5 9.99219 17.5C11.7327 17.5 ' +
    '13.4019 16.8086 14.6326 15.5779C15.8633 14.3472 16.5547 12.678 16.5547 10.9375C16.5547 ' +
    '6.87503 13.7422 3.75003 11.4609 1.47659L8.74219 7.18753L5.61719 5.10941Z'

  const flamePath2 =
    'M7.14282 13.7637C7.14282 14.5652 7.44384 15.3339 7.97966 15.9006C8.51548 16.4673 ' +
    '9.2422 16.7857 9.99997 16.7857C10.7577 16.7857 11.4845 16.4673 12.0203 15.9006C12.5561 ' +
    '15.3339 12.8571 14.5652 12.8571 13.7637C12.8571 10.7418 9.99997 8.92857 9.99997 8.92857C ' +
    '9.99997 8.92857 7.14282 10.7418 7.14282 13.7637Z'

  return (
    <Svg
      width={width}
      height={height}
      viewBox={withBorder ? '-4 -4 28 28' : '0 0 20 20'}
      fill="none"
    >
      {withBorder && (
        <Path
          d={flamePath1}
          fill="none"
          stroke={borderColor || '#FFFFFF'}
          strokeWidth="8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
      <Path
        d={flamePath1}
        fill="#FFBB36"
        stroke="#FFBB36"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path d={flamePath2} fill="#FF870E" />
    </Svg>
  )
}

export default StreakIcon
